<script lang="ts">
    import { defineAsyncComponent } from 'vue';
    import { defineComponent } from 'vue'; 
    const UnaP = defineAsyncComponent(() => import('./components/UnaP.vue'));
    const HumaVive = defineAsyncComponent(() => import('./components/HumaViveSlide.vue'))
    const TopBannerLeft =defineAsyncComponent(() => import('./components/oferta/TopBannerLeft.vue'))

    export default defineComponent({
        components: {  UnaP, HumaVive, TopBannerLeft },
        data() {
            return {
                showImage: true,
                showImage2: true,
                isAnimating: false,
                videoUrl: 'https://www.youtube.com/embed/kM6yarkMYr8?si=b8-0nC3xH0j-7yEn',
                videoUrl2: 'https://www.youtube.com/embed/YCaGNFgrM24?si=LM19H_6mYTzD3j0p',
                img: '/pagesImages/Aguila-Humanitas.webp',
                img2: '/pagesImages/video1.webp',
                // buttons: {
                //     button2: { imageUrl: './pagesImages/inscribete_white.png', hoverImageUrl: './pagesImages/inscribete_on.png' },
                // },
            };
        },
        methods: {
            showVideo() {
                this.showImage = false;
            },
            showVideo2() {
                this.showImage2 = false;
            },
        },
        mounted() {
            setTimeout(() => {
                this.isAnimating = true; // Actualiza la propiedad después del delay
            }, 0);
        },
    });
</script>

<template>
    <section class="flex items-center justify-center w-screen bg-cover bg-center bg-no-repeat mb-12 mt-20 lg:mt-32"
    style="background-image: url(/pagesImages/respons-banner.webp)">
        <div class="flex justify-center w-full max-w-4xl lg:max-w-[1200px] px-4">
            <div :class="['flex box flex-col items-center lg:text-justify lg:items-start my-14 lg:my-44 w-full text-white', { 'visible': isAnimating }]">
                <h1 class=" leading-tight mb-4">
                    <span class="block font-sans text-white leading-none mb-0 text-[30px]">Responsabilidad</span>
                    <span class="sr-only whitespace-nowrap">&nbsp;</span>
                    <span class="block font-serif text-white text-[50px]">Social</span>
                </h1>
                <p class="font-serif text-[19px] relative lg:static lg:-top-6">La esencia de la vida es servir a otros y hacer el bien.</p>
            </div>
        </div>
    </section>

    <!-- <TopBannerLeft :img="'background-image: url(../../pagesImages/modelo-ejec-respon.jpg);'" :nivel="'Responsabilidad'" :carrera="'Social'" :frase="'Enseñar a valorar el medio ambiente es enseñar a valorar la vida.'" :autor="''"/> -->

    <!-- <section class="flex items-center mb-12 justify-center w-full">
        <div class="lg:flex items-center justify-center w-full max-w-4xl lg:max-w-[1200px]">
            <div class="flex flex-col lg:w-1/2 px-4 md:px-0">
                <div class="leading-none my-5 w-full">
                    <h2>
                        <span class="block lg:text-left font-serif text-[54px] text-hgold">¿Qué es Humanitas?</span>
                    </h2>
                </div>
                <p class="text-justify mb-5">"Humanitas" es una palabra en latín que significa humanidad o cualidad de ser humano. En su sentido más profundo, hace referencia a valores como la educación, la cultura, la empatía y la dignidad humana. En la filosofía clásica, especialmente en la tradición romana, el término se asociaba con el ideal de formación integral del ser humano, promoviendo el conocimiento, la virtud y el sentido de responsabilidad hacia los demás.</p>
                <p class="text-justify">En el contexto de Universidad Humanitas, el nombre refuerza la idea de una educación basada en valores, crecimiento personal y compromiso con la sociedad.</p>
            </div>
            <div class="flex items-center lg:w-1/2 justify-center px-4 md:px-0">
                <img src="/pagesImages/que-es-humanitas.webp" alt="Representación del concepto de 'Humanitas': educación, cultura, empatía y dignidad humana, reflejando los valores de Universidad Humanitas." class="w-full lg:ml-12"/>
            </div>
        </div>
    </section> -->
    <section class="flex items-center mb-12 justify-center w-full">
        <div class="lg:flex items-center justify-center w-full max-w-4xl lg:max-w-[1200px]">
            <div class="flex flex-col lg:w-1/2 px-6 lg:px-0">
                <div class="leading-none my-5 w-full">
                    <h2>
                        <span class="block lg:text-left text-gray-500 text-[26px]">Compromiso social</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block lg:text-left font-serif text-[42px] text-hgold">Humanitas</span>
                    </h2>
                </div>
                <p class="text-justify hyphens-auto mb-4">En Universidad Humanitas, la responsabilidad social es un pilar fundamental de nuestra filosofía. Nos comprometemos activamente con la sociedad y el medio ambiente a través de campañas y programas que generan un impacto positivo, reflejando nuestra misión, visión y valores institucionales.</p>
                <p class="text-justify hyphens-auto mb-4">Apoyamos a instituciones que dan servicio a quienes lo necesitan, incluyendo niños, adolescentes, personas en situación de calle, pacientes con cáncer, personas con discapacidad y adultos mayores. También trabajamos en favor del bienestar animal mediante campañas de donación de alimento, esterilización y adopción.</p>
                <p class="text-justify hyphens-auto mb-8 lg:mb-0">En el rubro ambiental, promovemos iniciativas de limpieza de playas y bosques, así como programas de reciclaje, contribuyendo a un mundo más sostenible.</p>
            </div>
            <div class="flex items-center lg:w-1/2 justify-center px-6 lg:px-0">
                <img src="/pagesImages/responsabilidad-social-playa.webp" alt="Representación del concepto de 'Responsabilidad social': educación, cultura, empatía y dignidad humana, reflejando los valores de Universidad Humanitas." class="w-full lg:ml-12"/>
            </div>
        </div>
    </section>

    <section class="flex flex-col items-center mb-12 justify-center w-full">
        <div class="lg:flex items-center justify-start w-full max-w-4xl lg:max-w-[1200px]">
            <div class="flex flex-col md:px-4">
                <div class="leading-none mb-5">
                    <h2>
                        <span class="block lg:text-left text-gray-500 text-[26px]">Trabajamos</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block lg:text-left font-serif text-[42px] text-hgold">Juntos</span>
                    </h2>
                </div>
            </div>
        </div>
        <HumaVive class="w-full max-w-4xl lg:max-w-[1248px]" />
    </section>

    <!-- <EgresadosHuma :types="'QueEsHumanitas'" class="mb-12"/> -->

    <section class="flex items-center justify-center w-full">
        <div class="lg:flex justify-start w-full max-w-4xl lg:max-w-[1200px] items-center mb-12 px-4">
            <div class="flex flex-col lg:w-[50%] items-center text-justify lg:mr-12">
                <div class="text-justify">
                    <div class="text-center lg:text-left leading-tight">
                        <h2>
                            <span class="block text-gray-700 mb-0 leading-tight font-normal text-[28px]">Programa</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold mb-4 mt-0 leading-tight font-serif text-[42px]">Humanitas Vive</span>
                        </h2>
                    </div>
                    <h2 class="sr-only">liberar su servicio social</h2>
                    <p class="mb-4 hyphens-auto">Es nuestro programa de voluntariado, a través del cual los alumnos pueden liberar su servicio social participando en actividades de impacto social, altruismo y medio ambiente.</p>
                    <p class="mb-4 hyphens-auto">Colaboramos con instituciones autorizadas mediante donativos en especie o económicos y organizamos actividades alineadas con nuestra misión de transformar vidas.</p>
                    <p class="mb-8 lg:mb-0 hyphens-auto">Conoce más sobre nuestros programas y únete a esta causa. ¡Juntos podemos hacer la diferencia!</p>
                </div>
            </div>
            <div class="flex items-center justify-center"><img src="/pagesImages/programa-humanitas-vive-actividad-ambiental.jpg" loading="lazy" alt="Hombre y mujer plantando árbol"></div>
        </div>
    </section>

    <section class="flex items-center justify-center w-full">
        <div class="lg:flex justify-start w-full max-w-4xl lg:max-w-[1200px] items-center mb-12 px-6 lg:px-0">
            <div class="max-w-[1200px] w-full mx-auto">
                <div class="text-center lg:text-left leading-tight">
                    <!-- <h2>
                        <span class="block text-gray-700 mb-0 leading-tight font-normal text-[28px]">Testimonio compromiso</span>
                        <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block text-hgold mb-8 mt-0 leading-tight font-serif text-[42px]">ambiental Humanitas</span>
                    </h2> -->
                    <h3>
                        <span class="block font-serif mb-8 pl-4 text-hgold text-[28px]">Testimoniales del programa Humanitas Vive</span>
                        <!-- <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block font-serif mb-8 pl-4 text-hgold text-[28px]"></span> -->
                    </h3>
                </div>
                <div class="grid px-2 md:grid-cols-[auto_auto_auto] gx:grid-rows-1 gx:grid-cols-[auto_auto_auto_auto_auto] text-left gap-y-12 md:gap-x-4 gx:gap-3 relative z-10 w-full pb- bg-white">
                    <div class="order-1 w-full space-y-6 gx:px-2 gx:row-span-2">
                        <h4 class="text-xl text-hgold font-serif">Ayuda a los animales</h4>
                        <p class=" text-justify hyphens-auto">
                            "Todos los animales merecen recibir respeto, pues son seres vivos que sienten todo. Me gustaría poder contribuir con más tiempo, dándoles ese cariño que necesitan e ir a hacer más voluntariado.”
                        </p>
                        <p class="text-sm text-right">Griselda Janet Aguilar Diego,<br> estudiante Humanitas.</p>
                    </div>

                    <div class="hidden md:flex md:order-2 border-l-[1.2px] border-gray-400 gx:row-span-2">
                    </div>

                    <div class="order-2 md:order-3 w-full space-y-6 gx:px-2 gx:row-span-2">
                        <h4 class="text-xl text-hgold font-serif">Actividad de reforestación</h4>
                        <p class="text-justify hyphens-auto">
                            "Este acto simboliza esperanza y crecimiento, además, contribuye a crear un entorno más saludable y sostenible para las futuras generaciones...<br><br>Nos sentimos honrados de poder apoyar a estos valientes niños y sus familias y estamos comprometidos a   seguir trabajando juntos por un futuro mejor".
                        </p>
                        <p class="text-sm text-right">María Fernanda Amador Rodríguez,<br> estudiante Humanitas.</p>
                    </div>
                    
                    <div class="hidden gx:flex gx:order-4 border-l-[1.2px] border-gray-400 gx:row-span-2">
                    </div>
                    
                    <div class="order-3 md:order-4 gx:order-5 gx:px-2 w-full col-span-1 md:col-span-3 gx:col-span-1 space-y-6 gx:row-span-3">
                        <h4 class="text-xl text-hgold font-serif">Activación física para adultos mayores</h4>
                        <p class="text-justify hyphens-auto">
                            "Esta actividad me dejó un gran aprendizaje como ser humano... Yo sólo aporté mi tiempo y ellos me aportaron conocimiento, espontaneidad y afecto...<br><br>Feliz y satisfecha por pasar esta experiencia con nuestros adultos mayores que en algún momento fueron nuestros guías y maestros".

                        </p>
                        <p class="text-sm text-right">Rebeca Adriana Ortega Llanos,<br> estudiante Humanitas.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <section class="flex items-center justify-center w-full">
        <div class="lg:flex justify-start w-full max-w-4xl lg:max-w-[1200px] items-center lg:mb-12 px-6">
            <div class="flex flex-col lg:w-[50%] items-center text-justify lg:mr-12">
                <div class="text-justify">
                    <div class="text-center lg:text-left leading-tight">
                        <h2>
                            <span class="block text-gray-700 mb-0 leading-tight font-normal text-[28px]">Programa Humanitas</span>
                            <span class="sr-only whitespace-nowrap">&nbsp;</span>
                            <span class="block text-hgold mb-4 mt-0 leading-tight font-serif text-[42px]">Club Social Iluminate</span>
                        </h2>
                    </div>
                    <p class="mb-4 hyphens-auto">La Universidad Humanitas desarrolla el proyecto sin fines de lucro: Club Social lluminate, que brinda acceso a educación y actividades de desarrollo integral a grupos vulnerables en el estado de Morelos, México.</p>
                    <p class="mb-4 hyphens-auto">Con espacios equipados y especialistas en diversas disciplinas, el Club ofrece talleres, capacitaciones y actividades recreativas gratuitas para niños, jóvenes y adultos mayores.</p>
                    <p class="mb-8 lg:mb-0 hyphens-auto">Financiado por Universidad Humanitas, este programa es un referente de inclusión y desarrollo, el cual tiene un impacto social positivo, que radica en ampliar el acceso a la educación, fomentar el desarrollo personal y fortalecer la colaboración entre instituciones y la comunidad.</p>
                </div>
            </div>
            <div class="flex items-center justify-center"><img src="/pagesImages/actividad-club-social-lluminate-universidad-humanitas.webp" loading="lazy" alt="Actividad del Club Social Llluminate en la Universidad Humanitas"></div>
        </div>
    </section>

    <section class="flex w-full min-h-[600px] items-center justify-center bg-cover lg:bg-[center] bg-right bg-no-repeat" style="background-image: url(/pagesImages/fundaciones-humanitas.webp);">
        <div class="w-full min-h-[600px] lg:bg-transparent bg-white/60 flex items-center justify-center">
            <div class="flex flex-col max-w-4xl lg:max-w-[1200px] py-12 w-full lg:px-0 px-8 lg:bg-transparent ">
                <div class="flex flex-col items-start  justify-start lg:text-justify mb-12">
                    <h2 class="md:mb-6 mb-3">
                        <span class="block font-serif text-hwine lg:text-[28px] md:text-[24px] text-[22px]">Algunas instituciones a las que apoyamos</span>
                        <!-- <span class="sr-only whitespace-nowrap">&nbsp;</span>
                        <span class="block font-serif text-hgold text-[28px]">que apoyamos</span> -->
                    </h2>
                    <p class="text-justify text-gray-800 max-w-[500px] mb-6 w-full hyphens-auto">Colaboramos con diversas instituciones autorizadas para maximizar nuestro impacto en la sociedad. Ya sea a través de donaciones en especie, monetarias o mediante la organización de eventos y actividades, buscamos generar un cambio positivo y duradero.</p>
                    <p class="lg:text-[22px] md:text-[20px] font-times max-w-[600px] mb-3 w-full text-gray-800">“La felicidad se encuentra en servir a los demás.”</p>
                    <p class="text-center lg:text-[18px] max-w-[500px] w-full font-times italic text-gray-800">-Carl B. Cook-</p>
                </div>
                <div class="flex flex-col justify-center items-center max-w-[1200px] self-center w-full relative">
                    <!-- Indicador en móviles -->
                    <!-- <div class="absolute -top-6 left-1/2 -translate-x-1/2 text-black text-xs md:hidden animate-pulse">
                    Desliza para ver más →
                    </div> -->
                    <div class="w-full flex justify-center">
                        <div class="w-full max-w-[1200px] overflow-x-auto relative">
                            <div class="flex lg:justify-center md:flex-nowrap md:overflow-x-auto md:scroll-smooth text-black md:snap-x md:snap-mandatory gap-4">

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/fundacion-dar-y-amar.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Fundación dar y amar">
                                <h3 class="text-xs w-full text-center mb-6">Fundación <br>dar y amar</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/fundacion-mamita-y-lety.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Fundación Mamita y Lety">
                                <h3 class="text-xs w-full text-center mb-6">Fundación <br>Mamita y Lety</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/hogar-dulce-hogar.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Hogar Dulce Hogar IAP">
                                <h3 class="text-xs w-full text-center mb-6">Hogar Dulce<br> Hogar IAP</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/mosaico-urbano.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Mosaico Urbano">
                                <h3 class="text-xs w-full text-center mb-6">Mosaico <br>Urbano</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/nacion-verde.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Nación Verde">
                                <h3 class="text-xs w-full text-center mb-6">Nación <br>Verde</h3>
                            </div>
                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/apruevas.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Fundación Apruebas">
                                <h3 class="text-xs w-full text-center mb-6">Fundación <br>Apruevas</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/casa-belen.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Fundación Casa Bélen">
                                <h3 class="text-xs w-full text-center mb-6">Fundación <br>Casa Bélen</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/refugio-franciscano.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Refugio Franciscano">
                                <h3 class="text-xs w-full text-center mb-6">Refugio <br>Franciscano</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/asilo-san-sebastian.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Asilo San Sebastián">
                                <h3 class="text-xs w-full text-center mb-6">Asilo <br>San Sebastián</h3>
                            </div>

                            <div class="flex flex-col justify-center items-center flex-shrink-0 snap-center">
                                <img src="/pagesImages/asociacion-por-ninos.png" width="100" height="100" class="w-[100px] h-[100px]" alt="Asociación Pro niños">
                                <h3 class="text-xs w-full text-center mb-6">Asociación <br>Pro niños</h3>
                            </div>

                            </div>
                        </div>
                    </div>

                    <!-- Flecha de animación -->
                    <!-- <div class="absolute bottom-2 right-2 md:hidden">
                        <svg class="w-6 h-6 text-gray-400 animate-bounce" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                        </svg>
                    </div> -->
                    <div class="absolute bottom-0 right-0 md:hidden">
                        <svg class="w-6 h-6 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
                        </svg>
                    </div>

                </div>
            </div>
        </div>
    </section>

    <!-- <section class="flex flex-col lg:hidden w-full items-center justify-center my-12">
        <div class="flex items-center justify-start max-w-4xl lg:max-w-[1200px] w-full px-4">
            <div class="flex flex-col justify-start lg:text-justify">
                <p class="font-serif text-hgold text-[28px]">Algunas instituciones a las que apoyamos</p>
            </div>
        </div>
        <div class="w-screen">
            <img src="/pagesImages/fundaciones.jpg" loading="lazy" alt="Fundaciones" class="object-cover object-right h-[360px] min-[500px]:h-[420px]">
        </div>
        <div class="flex items-center justify-start max-w-4xl lg:max-w-[1200px] w-full px-4">
            <div class="flex flex-col justify-start lg:text-justify">
                <p class="font-bold text-[22px] font-times text-black">"Una vida no vivida por los demás no es una vida".</p>
                <p class="text-right text-[20px] font-times italic text-black">-Madre Teresa-</p>
            </div>
        </div>
    </section> -->
</template>

<style scoped>
.box {
  transform: translateX(-100%); /* Fuera del viewport */
    transition: transform 1.2s ease-in-out;
}

.box.visible {
  transform: translateX(0); /* Posición original */
}
</style>